export enum FormMode {
    Edit = 'edit',
    New = 'new',
}
